import { FilterOption } from './filter.model';

export const YES_NO_FILTER_OPTIONS: FilterOption[] = [
  { label: 'common.actions.yes', value: 'true', translate: true },
  { label: 'common.actions.no', value: 'false', translate: true },
];
